module.exports = __webpack_public_path__ + "static/media/vimeo.31a1bcbb.svg";